import { of, Subscription } from 'rxjs'
import { AppState } from 'src/app/core/core.state'

import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { operationInternalEventActions } from '../operation-internal-event.actions'
import { take, timeout, catchError } from 'rxjs/operators'
import { NotificationService } from 'src/app/core/notification.service'
import { persistentUserRoleSelectors } from 'src/app/features/role/user-role/persistent-user-role/persistent-user-role.selector'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'operation-internal-event-create',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OperationInternalEventCreateComponent
  implements OnInit, OnDestroy
{
  private subscriptions: Subscription[] = []

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    // this.subscriptions.push(
    //   this.actions$
    //     .pipe(ofType(operationInternalEventActions.upsertMany))
    //     .subscribe((action) =>
    //       this.router.navigate([
    //         '/operation-internal-events',
    //         action.entities[0].id
    //       ])
    //     )
    // )
  }

  public onSubmit(form): void {
    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(take(1))
      .subscribe((pUr) => {
        const siteId =
          pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId

        delete form?.value
        delete form?.fromField
        delete form?.toField
        this.store.dispatch(
          operationInternalEventActions.createOne({
            entity: {
              ...form
            }
          })
        )
      })

    this.actions$
      .pipe(
        ofType(operationInternalEventActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }

  ngOnDestroy() {
    this.subscriptions.map((s) => s.unsubscribe())
  }
}
